<template>
  <div>
    <div class="regularWarehouseBill">
      <!-- 费用管理 常规仓库账单 -->
      <baseBreadcrumb :page="$t('message.regularWarehouseBill')" :menu="$t('message.costManagement')">
      </baseBreadcrumb>
      <div class="body" v-show="!isDetail">
        <el-tabs v-model="datas.detail_category" type="card" class="bill-tabs" @tab-click="handleTabChange">
          <el-tab-pane label="常规仓库-散货" name="stock"></el-tab-pane>
          <el-tab-pane label="常规仓库-装箱" name="order"></el-tab-pane>
        </el-tabs>
        <div class="search">
          <!-- 客户ID/客户名称 -->
          <div class="item">
            <el-input v-model="datas.user_id_or_name" :placeholder="$t('message.customerID_CustomerName')"></el-input>
          </div>
          <!-- 开始日期 -->
          <div class="item">
            <el-date-picker v-model="datas.start_date" type="date" value-format="yyyy-MM-dd"
              :placeholder="$t('message.startDate')">
            </el-date-picker>
          </div>
          <!-- 结束日期 -->
          <div class="item">
            <el-date-picker v-model="datas.end_date" type="date" value-format="yyyy-MM-dd"
              :placeholder="$t('message.endTime')">
            </el-date-picker>
          </div>
          <!-- 结算状态 -->
          <div class="item">
            <el-select v-model="datas.status" :placeholder="$t('message.settlementStatus')">
              <el-option label="待结算" value="0"></el-option>
              <el-option label="已结算" value="1"></el-option>
              <!-- <el-option label="已取消" value="2"></el-option> -->
            </el-select>
          </div>
          <!-- 查询按钮 -->
          <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
          <!-- 重置按钮 -->
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        </div>
        <div class="table">
          <ol style="background-color: #EDEFF4;">
            <li class="flex05">No</li>
            <!-- 客户信息 -->
            <li>{{ $t('message.userInfo') }}</li>
            <!-- 账单号 -->
            <li>{{ $t('message.billNumber') }}</li>
            <!-- 散货显示SKU数量，装箱显示计费箱数 -->
            <li>{{ isStockBill ? $t('message.numberOfSKUs') : $t('message.feeBoxNumber') }}</li>
            <!-- 商品数量：散货不显示 -->
            <li v-if="!isStockBill">{{ $t('message.productNumber') }}</li>
            <!-- 常规仓储费总金额-->
            <li>{{ $t('message.regularStorageFeeTotalAmount') }}</li>
            <!-- 结算状态 -->
            <li>{{ $t('message.settlementStatus') }}</li>
            <!-- 账单日期 -->
            <li>{{ $t('message.billDate') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ item.rowNumber }}</li>
            <!-- 客户信息 -->
            <li>
              <div>
                <p>ID:{{ item.user_id }}</p>
                <p>{{ item.realname }}</p>
              </div>
            </li>
            <!-- 账单号 -->
            <li>
              <el-button type="text" @click="showDetail(item.id)">{{ item.bill_sn }}</el-button>
            </li>
            <!-- 散货显示SKU数量，装箱显示计费箱数 -->
            <li>{{ isStockBill ? (item.sku_count != null ? item.sku_count : '-') : item.box_count }}</li>
            <!-- 商品数量：散货不显示 -->
            <li v-if="!isStockBill">{{ item.goods_count }}</li>
            <!-- 常规仓储费总金额-->
            <li>{{ item.total_fee }}</li>
            <!-- 结算状态 -->
            <li>{{ item.status_name }}</li>
            <!-- 账单日期 -->
            <li>{{ item.bill_date }}</li>
          </ul>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total" :page-size="datas.pageSize"
            v-model:current-page="datas.page" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 详情 -->
    <Detail v-show="isDetail" ref="detail"></Detail>
  </div>
</template>
<script>
import Detail from './conponents/detail.vue'
export default {
  components: {
    Detail,
  },
  computed: {
    isStockBill() {
      return this.datas.detail_category === 'stock'
    }
  },
  data() {
    return {
      isDetail: false,
      tableData: [],
      total: 0,
      datas: {
        bill_type: 'client',
        user_id_or_name: '',
        bill_sn: '',
        status: '',
        bill_date_start: '',
        bill_date_end: '',
        detail_category: 'stock',
        page: 1,
        pageSize: 10,
      }
    }
  },

  created() {
    this.regularStorageBillList();
  },
  methods: {
    // 常规仓库账单-获取计费类型列表
    regularStorageBillList() {
      this.$api.costManagementApi.regularStorageBillList(this.datas).then(res => {

        this.tableData = res.data.data;
        this.total = res.data.total;
      })
    },
    // 分页-每页条数改变
    handleSizeChange(val) {
      this.datas.page = 1
      this.datas.pageSize = val;
      this.regularStorageBillList();
    },
    // 分页-当前页改变
    handleCurrentChange(val) {
      this.datas.page = val;
      this.regularStorageBillList();
    },
    // 切换常规仓库账单类型：散货 stock，装箱 order
    handleTabChange() {
      this.datas.page = 1
      this.regularStorageBillList()
    },
    // 查询
    search() {
      this.datas.page = 1
      this.regularStorageBillList();
    },
    // 重置
    reset() {
      const detailCategory = this.datas.detail_category || 'stock'
      this.datas = {
        user_id_or_name: '',
        bill_sn: '',
        status: '',
        bill_date_start: '',
        bill_date_end: '',
        detail_category: detailCategory,
        page: 1,
        pageSize: 10,
      }
      this.regularStorageBillList();
    },
    // 常规仓库账单-获取详情
    showDetail(bill_id) {
      this.$refs.detail.bill_id = bill_id
      this.$refs.detail.detail_category = this.datas.detail_category
      this.$refs.detail.regularStorageBillDetail()
      this.isDetail = true
    },



  }
}
</script>
<style scoped lang="scss">
.regularWarehouseBill {
  .bill-tabs {
    margin-bottom: 20px;
  }

  .search {
    margin-bottom: 20px;
    display: flex;

    .item {
      width: 200px;
      margin-right: 20px;

      .el-date-editor {
        width: 100%;
      }
    }
  }

  .table {
    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }

    ol {
      background: #DCDFE6;
      height: 56px;
      line-height: 56px;
      color: #666666;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
      text-align: center;



      p {
        line-height: 22px;
        margin-bottom: 6px;

        .el-button {
          width: 80px;
          padding: 11px 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .template {
      width: 100%;
      text-align: left;

      .row {
        margin-bottom: 12px;
      }
    }
  }
}
</style>
